/**
 * Inventory Validator Helper
 * Validates if a product variant can be added to cart based on online quantity
 */

/**
 * Validates if a variant can be added to cart
 * @param {string} productHandle - Product handle (e.g., "my-product")
 * @param {number|string} variantId - Variant ID
 * @param {number} quantity - Quantity to add
 * @param {boolean} hasStoreId - Whether the item has store_id property
 * @returns {Promise<{canAdd: boolean, message: string, data: object}>}
 */
async function validateInventory(productHandle, variantId, quantity, hasStoreId) {

  let url = `${window.Shopify.routes.root}products/${productHandle}?view=inventory&variant=${variantId}`; 
  if ( window.Shopify.theme.role != 'main') {
    url += `?preview_theme_id=${window.Shopify.theme.id}`;
  }

  try {
    // Fetch inventory data (cacheable)
    const response = await fetch(url);

    if (!response.ok) {
      return {
        canAdd: false,
        message: 'Unable to check inventory. Please try again.',
        data: null
      };
    }

    const inventoryData = await response.json();

    // Determine if validation is required (logic in JS, not in Liquid)
    const isLoggedIn = document.body.classList.contains('customer-logged-in');
    const requiresValidation = !(isLoggedIn && hasStoreId || isLoggedIn && window.store);

    // If validation is not required, allow adding without checking stock
    if (!requiresValidation) {
      return {
        canAdd: true,
        message: '',
        data: inventoryData
      };
    }

    // If validation is required, check available quantity
    if (quantity > inventoryData.available_quantity) {
      return {
        canAdd: false,
        message: 'This product is out of stock',
        data: inventoryData
      };
    }

    // All good, allow adding to cart
    return {
      canAdd: true,
      message: '',
      data: inventoryData
    };

  } catch (error) {
    console.error('Inventory validation error:', error);
    return {
      canAdd: false,
      message: 'An error occurred. Please try again.',
      data: null
    };
  }
}

// Export for use in other files
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { validateInventory };
}
